export default "__VITE_ASSET__bf2b4862__"